import React, { useState } from 'react';
import { MdCheck } from 'react-icons/md';

import NextImage from 'next/image';

import env from '../../config/env';
import { WatchProvider as WatchProviderType } from '../../types/types';

interface PropTypes {
  data: WatchProviderType;
  alt?: string;
  onClick?: (event?: React.MouseEvent<HTMLDivElement>) => void;
  onSelect?: () => void;
  onUnselect?: () => void;
  isSelectable?: boolean;
  isSelected?: boolean;
  className?: string;
}

function WatchProvider({
  data,
  alt,
  onClick,
  onSelect,
  onUnselect,
  isSelectable,
  isSelected,
  className
}: PropTypes) {
  const [isSelectedState, setIsSelected] = useState(false);

  function handleClick(event: any) {
    if (isSelectable) {
      setIsSelected(!isSelectedState);
      if (onSelect) {
        onSelect();
      }
    }

    if (onClick) {
      onClick(event);
    }
  }

  return (
    <div
      className={`flex flex-col items-center rounded-md relative w-[70px] md:w-[90px] h-[70px] md:h-[90px] ${className}`}
      onClick={handleClick}
    >
      <NextImage
        className="transition-all-[250ms] hover:opacity-[0.4] cursor-pointer rounded-md w-full h-full"
        sizes="
        (min-width: 300px) 70px,70px
        (min-width: 768px) 90px,90px"
        unoptimized
        width={70}
        height={70}
        src={`${env.CDN_URL}${data?.icon}`}
        alt={alt || ''}
      />
      {isSelected && (
        <div className="flex flex-row absolute w-full h-full rounded-md justify-center items-center z-[2] top-0 right-0 left-0 bottom-0">
          <button
            style={{
              width: '100%',
              height: '100%',
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center'
            }}
            onClick={event => {
              event.stopPropagation();
              setIsSelected(!isSelectedState);
              if (onUnselect) {
                onUnselect();
              }
            }}
          >
            <MdCheck size="28" />
          </button>
        </div>
      )}
    </div>
  );
}

export default WatchProvider;
